import React from "react";

interface SportsProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
  stroke?: string;
  width?: number | string;
  height?: number | string;
}

const Sports: React.FC<SportsProps> = ({
  fill = "#3C3C3C",
  stroke = "none",
  width = 24,
  height = 24,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.67324 15.3C4.42324 14.7167 5.01074 14.0083 5.43574 13.175C5.86074 12.3417 6.07324 11.45 6.07324 10.5C6.07324 9.55 5.86074 8.65833 5.43574 7.825C5.01074 6.99167 4.42324 6.28333 3.67324 5.7C3.15658 6.4 2.76074 7.15833 2.48574 7.975C2.21074 8.79167 2.07324 9.63333 2.07324 10.5C2.07324 11.3667 2.21074 12.2083 2.48574 13.025C2.76074 13.8417 3.15658 14.6 3.67324 15.3ZM10.0732 18.5C10.9899 18.5 11.8774 18.3542 12.7357 18.0625C13.5941 17.7708 14.3732 17.3333 15.0732 16.75C14.1232 15.9833 13.3857 15.0542 12.8607 13.9625C12.3357 12.8708 12.0732 11.7167 12.0732 10.5C12.0732 9.28333 12.3357 8.12917 12.8607 7.0375C13.3857 5.94583 14.1232 5.01667 15.0732 4.25C14.3732 3.66667 13.5941 3.22917 12.7357 2.9375C11.8774 2.64583 10.9899 2.5 10.0732 2.5C9.15658 2.5 8.26908 2.64583 7.41074 2.9375C6.55241 3.22917 5.77324 3.66667 5.07324 4.25C6.02324 5.01667 6.76074 5.94583 7.28574 7.0375C7.81074 8.12917 8.07324 9.28333 8.07324 10.5C8.07324 11.7167 7.81074 12.8708 7.28574 13.9625C6.76074 15.0542 6.02324 15.9833 5.07324 16.75C5.77324 17.3333 6.55241 17.7708 7.41074 18.0625C8.26908 18.3542 9.15658 18.5 10.0732 18.5ZM16.4732 15.3C16.9899 14.6 17.3857 13.8417 17.6607 13.025C17.9357 12.2083 18.0732 11.3667 18.0732 10.5C18.0732 9.63333 17.9357 8.79167 17.6607 7.975C17.3857 7.15833 16.9899 6.4 16.4732 5.7C15.7232 6.28333 15.1357 6.99167 14.7107 7.825C14.2857 8.65833 14.0732 9.55 14.0732 10.5C14.0732 11.45 14.2857 12.3417 14.7107 13.175C15.1357 14.0083 15.7232 14.7167 16.4732 15.3ZM10.0732 20.5C8.68991 20.5 7.38991 20.2375 6.17324 19.7125C4.95658 19.1875 3.89824 18.475 2.99824 17.575C2.09824 16.675 1.38574 15.6167 0.860742 14.4C0.335742 13.1833 0.0732422 11.8833 0.0732422 10.5C0.0732422 9.11667 0.335742 7.81667 0.860742 6.6C1.38574 5.38333 2.09824 4.325 2.99824 3.425C3.89824 2.525 4.95658 1.8125 6.17324 1.2875C7.38991 0.7625 8.68991 0.5 10.0732 0.5C11.4566 0.5 12.7566 0.7625 13.9732 1.2875C15.1899 1.8125 16.2482 2.525 17.1482 3.425C18.0482 4.325 18.7607 5.38333 19.2857 6.6C19.8107 7.81667 20.0732 9.11667 20.0732 10.5C20.0732 11.8833 19.8107 13.1833 19.2857 14.4C18.7607 15.6167 18.0482 16.675 17.1482 17.575C16.2482 18.475 15.1899 19.1875 13.9732 19.7125C12.7566 20.2375 11.4566 20.5 10.0732 20.5Z"
        fill={fill}
        stroke={stroke}
      />
    </svg>
  );
};

export default Sports;
